import feed1 from '../../assets/images/profile.png';
import { IUserType } from './types/IUserType';

export const data: IUserType = {
    profileImage: feed1,
    fullName: 'Jacob Jones',
    jobTitle: 'Brand Strategist',
    isAccountVerified: true
};
